import { map } from 'lodash';

class DiscountsListController {

  constructor($scope, $state, discountService, messageService, access) {
    this.$scope = $scope;
    this.$state = $state;
    this.discountService = discountService;
    this.messageService = messageService;
    this.access = access;
  }

  $onInit() {
    this.updatePaging();
    this.$scope.$watch(
      function (scope) {
        return scope.current_page;
      },
      function (newVal, oldVal, scope) {
        if (newVal !== oldVal){
          if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered){
            scope.$ctrl.discounts = undefined;
            scope.$ctrl.discountService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(response => {
              scope.$ctrl.discounts = response;
              scope.$ctrl.loading = false;
            });
          }
          else{
            scope.$ctrl.discountService.findAll(newVal, scope.per_page)
              .then(list => scope.$ctrl.discounts = list);
          }
        }
      }
    );
  }

  updatePaging(){
    this.$scope.per_page = this.discounts.per_page;
    this.$scope.current_page = this.discounts.current_page;
    this.$scope.total = this.discounts.total;
  }

  onDelete(discount) {
    this.discountService.delete(discount.id)
      .then(() => {
        this.messageService.success(`The discount <strong>${discount.code}</strong> was successfully deleted.`);
        this.messageService.push();
      })
      .catch((error) => {
        this.messageService.failure(`The discount <strong>${discount.code}</strong> could not be successfully deleted: ${error.statusText}`);
        this.messageService.push();
      })
      .then(() => {
        let page = this.discounts.current_page;
        this.discounts = [];
        this.loading = true;
        return this.discountService.findAll(page).then(response => {
            this.discounts = response;
            this.loading = false;
        });
      });
  }

  filter(){
    if (!this.loading && this.filtertext){
      this.isFiltered = true;
      this.discounts = undefined;
      this.loading = true;
      this.discountService.search(this.filtertype, this.filtertext).then(response => {
        this.discounts = response;
        this.updatePaging();
        this.loading = false;
      });
    }
  }

  clearfilter(){
    if (this.isFiltered) {
      this.isFiltered = false;
      this.loading = true;
      this.discountService.findAll(1, 20).then(response => {
        this.discounts = response;
        this.$scope.current_page = 1;
        this.$scope.total = response.total;
        this.loading = false;
      });
    }
  }

  filtertypeChange() {
    switch(this.filtertype) {
      case 'status':
        this.filtertext = '1';
        break;
      default:
        this.filtertext = '';
        break;
    }
  }
}

DiscountsListController.$inject = [ '$scope', '$state', 'discountService', 'messageService', 'access' ];

export default DiscountsListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/discounts/controllers/discount.list.controller.js